import { IFascicolo, IProtocol, ISearchTableState, IWorkspaceTableState } from '../../shared/interfaces'

export interface AppNavigationState {
    protocol?: IProtocol;
    searchTableState?: ISearchTableState;
    workspaceTableState?: IWorkspaceTableState;
    fascicolo?: Partial<IFascicolo>;
    previousLocationPathName?: string;
}

export const UPDATE_APP_NAVIGATION_STATE = 'UPDATE_APP_NAVIGATION_STATE'
interface UpdateAppNavigationStateAction {
    type: typeof UPDATE_APP_NAVIGATION_STATE
    payload: AppNavigationState
}

export const SET_PROTOCOL = 'SET_PROTOCOL'
interface SetProtocolAction {
    type: typeof SET_PROTOCOL
    protocol?: IProtocol
}

export const UNSET_PROTOCOL = 'UNSET_PROTOCOL'
interface UnsetProtocolAction {
    type: typeof UNSET_PROTOCOL
}

export const SET_FASCICOLO = 'SET_FASCICOLO'
interface SetFascicoloAction {
    type: typeof SET_FASCICOLO
    fascicolo?: Partial<IFascicolo>
}

export const UNSET_FASCICOLO = 'UNSET_FASCICOLO'
interface UnsetFascicoloAction {
    type: typeof UNSET_FASCICOLO
}

export const SET_SEARCH_TABLE_STATE = 'SET_SEARCH_TABLE_STATE'
interface SetProtocolsTableStateAction {
    type: typeof SET_SEARCH_TABLE_STATE
    protocolsTableState?: ISearchTableState;
}

export const UNSET_SEARCH_TABLE_STATE = 'UNSET_SEARCH_TABLE_STATE'
interface UnsetProtocolsTableStateAction {
    type: typeof UNSET_SEARCH_TABLE_STATE
}

export const SET_WORKSPACE_TABLE_STATE = 'SET_WORKSPACE_TABLE_STATE'
interface SetWorkspaceTableStateAction {
    type: typeof SET_WORKSPACE_TABLE_STATE
    workspaceTableState?: IWorkspaceTableState;
}

export const UNSET_WORKSPACE_TABLE_STATE = 'UNSET_WORKSPACE_TABLE_STATE'
interface UnsetWorkspaceTableStateAction {
    type: typeof UNSET_WORKSPACE_TABLE_STATE
}

export const SET_PREVIOUS_LOCATION_PATHNAME = 'SET_PREVIOUS_LOCATION_PATHNAME'
interface SetPreviousLocationPathNameAction {
    type: typeof SET_PREVIOUS_LOCATION_PATHNAME
    previousLocationPathName: string
}

export const UNSET_PREVIOUS_LOCATION_PATHNAME = 'UNSET_PREVIOUS_LOCATION_PATHNAME'
interface UnsetPreviousLocationPathNameAction {
    type: typeof UNSET_PREVIOUS_LOCATION_PATHNAME
}

export type AppNavigationActionTypes = UpdateAppNavigationStateAction
    | SetProtocolAction | UnsetProtocolAction
    | SetFascicoloAction | UnsetFascicoloAction
    | SetProtocolsTableStateAction | UnsetProtocolsTableStateAction
    | SetWorkspaceTableStateAction | UnsetWorkspaceTableStateAction
    | SetPreviousLocationPathNameAction | UnsetPreviousLocationPathNameAction